import { list } from "./list";
import { timeSlots } from "./timeSlots";
import { priceRanges } from "./priceRanges";
import { reserve } from "./reserve";
import { cancelReservation } from "./cancelReservation";

export const PackagesEndpoint = {
  list,
  timeSlots,
  priceRanges,
  reserve,
  cancelReservation,
};
